//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        placeholder: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: 'text'
        },
        value: {
            default: null
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        inputListeners: function inputListeners() {
            var vm = this;
            // `Object.assign` merges objects together to form a new object
            return Object.assign({},
            // We add all the listeners from the parent
            this.$listeners,
            // Then we can add custom listeners or override the
            // behavior of some listeners.
            {
                // This ensures that the component works with v-model
                input: function input(event) {
                    vm.$emit('input', event.target.value);
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/Input.vue
// module id = 10lj
// module chunks = 0 1